import { OfferMemberStatus } from '../components/MemberTable/types';
import { CONVERSION_STATUS } from '../utils/getTagType';

export enum OFFER_ACTIONS {
  RESTORED = 'Restored',
  DELETED = 'Deleted',
  UPDATED = 'Updated',
  CREATED = 'Created',
}

export enum AFFILIATE_OFFER_LINK_STATUS {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  DISABLED = 'DISABLED',
  PENDING_PAUSE = 'PENDING PAUSE',
  PENDING_UNPAUSE = 'PENDING UNPAUSE',
  FAILED_UPDATE = 'FAILED_UPDATE',
  DELETING = 'DELETING',
}

const STATUS_COLOR_MAP: Record<string, string> = {
  [OfferMemberStatus.PAUSED]: 'bg-yellow-2',
  [CONVERSION_STATUS.DUPLICATE]: 'bg-yellow-2',
  [OfferMemberStatus.EXPIRED]: 'bg-red-2',
  [OfferMemberStatus.DEACTIVATED]: 'bg-red-2',
  [CONVERSION_STATUS.REJECTED]: 'bg-red-2',
  [OfferMemberStatus.ACTIVE]: 'bg-green-2',
  [CONVERSION_STATUS.ACCEPTED]: 'bg-green-2',
  [CONVERSION_STATUS.CANCELED]: 'bg-grey-2',
};

export const getTagColor = (status: string): string => {
  return STATUS_COLOR_MAP[status] || 'bg-grey-2';
};
export const AutomatedPayoutLabel = 'Automated Tiers';
export const AUTOMATED_PAYOUT_ID = -1000; // this is just for front end handling, not using in backend.
